<script>

//import axios from "axios";
import api from '@/helpers/api-rest/api.js';

export default {
  props: {
      showInfo: Boolean
  },
  data() {
    return {
      company_types: [],
      userType: null,
      userName: null,
      sendId: true,
      filterArray: [],
      searchQuery: ''
    }
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    loadDataCompanyType(){
      const apiEndpoint = `/api/v1/company-types`;
      let categoryCompany = (this.userType == 'consumer') ? 'production' : (this.userType == 'production') ? 'consumer' : '';
      api.get({url:apiEndpoint, params: {
        category: categoryCompany
      }})
        .then(response => {
          this.company_types = response.data;
        })
        .catch(error => {
          console.error("Error loading data:", error);
        });
    },
    filterMap(id){

      const index = this.filterArray.indexOf(id); // Busca el índice del id en filterArray

      if (index !== -1) {
        // Si el id ya está en filterArray, lo eliminamos
        this.filterArray.splice(index, 1);
      } else {
        // Si el id no está en filterArray, lo agregamos
        this.filterArray.push(id);
      }

        //this.filterArray.push(id);
        const filterArrayJSON = JSON.stringify(this.filterArray);
        this.$emit('filter', filterArrayJSON);
      
    },
    isSelected(id) {
      return this.filterArray.includes(id);
    },
    searchCompanies() {
      // Emitir un evento personalizado con el valor del input
      this.$emit('search', this.searchQuery);
    }
  },
  mounted(){
    const user = JSON.parse(localStorage.getItem('user'));
    this.userName = user?.name;
    this.userType = user?.roles[0]?.slug;
    console.log(this.userType);
    this.loadDataCompanyType();
  }
};
</script>

<template>
  <header id="page-topbar-map">
    <div class="navbar-header" style="padding: 50px;">
      <div class="d-block" v-if="showInfo === false">
        <h1 class="title-h1">Echo H2 System</h1>
        <p class="subtitle-h1">{{ this.userName }}</p>
      </div>
      
      <div class="d-flex" v-if="showInfo">
        <!-- App Search-->
        <form class="app-search d-none d-lg-block" style="width: 300px;">
          <div class="position-relative">
            <span class="ri-search-line"></span>
            <input type="text" class="form-control" :placeholder="$t('navbar.search-map.text')" v-model="searchQuery" @input="searchCompanies" />
          </div>
        </form>
      </div>
      
      <div class="d-flex" style="margin-right: 50px;align-items: center;">
        <div class="d-flex button-items" v-if="showInfo">
          <div v-for="company in company_types" :key="company.id">
            <b-button @click="filterMap(company.id)" pill variant="light" v-bind:class="{ 'selected': isSelected(company.id) }">
              <img v-bind:src=company.icon_url width="18px" height="18px"/> {{ company.name }}
            </b-button>
          </div>
        </div>
        <div class="dropdown d-inline-block d-lg-none ml-2" v-if="showInfo">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            id="page-header-search-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="ri-search-line"></i>
          </button>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-search-dropdown"
          >
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search ..." />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="ri-search-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <!-- <img class="rounded-circle header-profile-user" src="@/assets/images/users/icon-user.png" alt="Header Avatar"/> -->
            <img class="rounded-circle" src="@/assets/images/users/icon-user.png" alt="Header Avatar"/>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.profile') }}
          </a>
          <div class="dropdown-divider"></div>
          <router-link :to="'logout'" class="dropdown-item text-danger">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.kevin.list.logout') }}
          </router-link>
          <!-- <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.kevin.list.logout') }}
          </a> -->
        </b-dropdown>
      </div>
    </div>
  </header>
</template>